import React, { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom';
import { routes } from '../../config/routesConfig';
import { cn } from '../../utils/utils';
import { LucideChevronLeft, LucideChevronRight } from 'lucide-react';

type Props = {}

function Breadcrumb({}: Props) {
      const path = useLocation().pathname;
      const [searchParams] = useSearchParams();
      const [navInfo, setNavInfo] = useState<any>({});
        const [queryParams, setQueryParams] = useState<
          { key: string; value: string }[]
        >([]);
          const hiddenKeys = [
    "id",
    "section",
    "max",
    "price",
    "min",
    "currentPage",
    "currentSize",
    "booking_type"
  ];
      const handleNavbarInfo = () => {
        let PathWithoutQuery = path.split("?")[0];
    
        const navInfo = routes.find((item) => {
          let currentItem = item;
          let currentPath = PathWithoutQuery;
          if (item.path.indexOf(":") !== -1) {
            //
    
            currentItem = { ...item, path: item.path.split(":")[0] };
            currentPath = currentPath.slice(0, currentPath.lastIndexOf("/"));
            //
            return (
              currentItem.path === currentPath ||
              currentItem.path === currentPath + "/" ||
              currentItem.path === currentPath.substring(0, currentPath.length - 1)
            );
          } else {
            return (
              item.path === PathWithoutQuery ||
              item.path === PathWithoutQuery + "/" ||
              item.path ===
                PathWithoutQuery.substring(0, PathWithoutQuery.length - 1)
            );
          }
        });
        setNavInfo(navInfo);
        console.log(navInfo);
        
      };
      useEffect(() => {
        const tempQueryParams: { key: string; value: string }[] = [];
        searchParams.forEach((valueEl, keyEl) => {
          if (!hiddenKeys.includes(keyEl)) {
            tempQueryParams.push({ value: valueEl, key: keyEl });
          }
        });
        setQueryParams(tempQueryParams);
        handleNavbarInfo();
      }, [path, window.location.search]);
  return (
    <div className={cn('flex gap-2 items-center mb-[26px]  my-[6px]',navInfo?.BreadcrumbItems?.length === 0&&'hidden')}>
        {navInfo?.BreadcrumbItems?navInfo?.BreadcrumbItems.map((item:string,index:number) =>(
          <>
             <span className={cn("bg-[#EEF4FF] py-[9px] px-[23px] rounded-full text-[16px]  block w-fit",index !== navInfo?.BreadcrumbItems?.length-1 && "text-primaryGreen bg-[#E2F0E9]")}>{index+1}. {item} </span>{index !== navInfo?.BreadcrumbItems?.length-1&& <LucideChevronRight  />}
          </>
     
    )):null} 
    </div>
    

  )
}

export default Breadcrumb